import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-12 bg-primary-900">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="lg:w-1/2">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-800 text-primary-200 text-xs font-medium mb-4">
              Getting Started
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-5">
              What Is Litbuy Spreadsheet?
            </h2>
            <p className="text-primary-100 text-sm md:text-base leading-relaxed mb-4">
              Litbuy Spreadsheet is a modern, intuitive spreadsheet platform designed to help users manage data, track projects, and collaborate seamlessly. Whether you are a beginner or an experienced data analyst, Litbuy Spreadsheet provides the tools you need to work smarter and faster.
            </p>
            <p className="text-primary-200/80 text-sm leading-relaxed mb-6">
              With built-in automation features, a rich template library, and real-time collaboration capabilities, Litbuy Spreadsheet stands out as a versatile alternative to traditional spreadsheet applications. Its user-friendly interface makes data management accessible to everyone.
            </p>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/article/what-is-litbuy-spreadsheet"
                className="px-6 py-2.5 rounded-full bg-background-50 text-primary-900 font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-background-100 transition-all"
              >
                Read Full Guide
              </Link>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="px-6 py-2.5 rounded-full border border-primary-400 text-primary-200 font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-primary-800 transition-all"
              >
                Visit Store &rarr;
              </a>
            </div>
          </div>

          <div className="lg:w-1/2">
            <div className="bg-primary-800/50 rounded-xl p-6 md:p-8 border border-primary-700/30">
              <h3 className="font-heading text-xl text-background-50 font-semibold mb-5">Key Features at a Glance</h3>
              <div className="space-y-4">
                {[
                  { icon: 'ri-flashlight-line', title: 'Smart Automation', desc: 'Automate repetitive tasks with built-in workflows and formula assistants' },
                  { icon: 'ri-group-line', title: 'Real-Time Collaboration', desc: 'Work together with team members on the same spreadsheet simultaneously' },
                  { icon: 'ri-file-copy-line', title: 'Rich Template Library', desc: 'Access hundreds of pre-built templates for budgeting, project management, and more' },
                  { icon: 'ri-bar-chart-2-line', title: 'Advanced Analytics', desc: 'Generate insights with powerful data visualization and reporting tools' },
                ].map((feat) => (
                  <div key={feat.title} className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-700 text-primary-200 flex-shrink-0">
                      <i className={`${feat.icon} text-lg`}></i>
                    </div>
                    <div>
                      <h4 className="text-background-50 font-semibold text-sm">{feat.title}</h4>
                      <p className="text-primary-300/80 text-xs mt-0.5">{feat.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}